<template>
  <div class="layout-row flex-gt-sm-100 flex-100 layout-wrap">
    <div class="flex-gt-sm-33 flex-100 pl-2 pr-1">
      <validation-provider tag="div"
                           :name="path + '.tnm_datum'"
                           :ref="path + '.tnm_datum'"
                           :rules="{required :isTNMDateRequired,german_date:true,date_not_in_future:true,tnm_date_must_be_empty:[isRequired, model],date_must_be_lesser_than_death:[deathDate, null],date_must_be_greater_than_diagnosis:diagDate}"
                           v-slot="{ errors }">
        <lx-datepicker
            :color="compColor.textInput"
            :name="path + '.tnm_datum'"
            :label="setLabelInDependencyToRequiredState($t('FORMS_DIVERSE.TNM_DATE'))"
            class="mb-4"
            :hide-details="!errors || errors.length <= 0"
            :disabled="isDisabled"
            :dense="denseFields"
            :error="errors[0]"
            @input="setDefaultClassification(model.tnm_datum)"
            v-model="model.tnm_datum"
        ></lx-datepicker>
      </validation-provider>
    </div>

    <!-- TNM -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame label="TNM"
                        :disabled="isDisabled">
        <div class="layout-column px-2 flex-100">
          <div class="layout-row pt-4 flex-100">

            <!-- y/r/a -->

            <div class="flex-gt-sm-33 flex-100 px-2 layout-row">
              <validation-provider tag="div"
                                   class="flex"
                                   :name="path + '.classification'"
                                   :ref="path + '.classification'"
                                   rules="">
                <v-select
                  :color="compColor.primeColor"
                  label="y/r/a - Klassifikation"
                  v-model="prefixClassification"
                  :items="prefixClassificationTypes"
                  outlined
                  :menu-props="{ bottom: true, offsetY: true }"
                  multiple
                  :disabled="isDisabled"
                  :dense="denseFields"
                  @change="tnmPrefixIsClicked(prefixClassification)"
                  hide-details
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{item, on, attrs}">
                    <v-list-item v-on="on" style="height: 40px;">
                      <v-list-item-action style="margin-right: 10px">
                        <v-simple-checkbox
                          :value="attrs.inputValue"
                          v-on="on"
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :ripple="false"
                        ></v-simple-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>
                          <label :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                 class="lighten-4 text--darken-2"
                                 :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}"
                          >{{ item.textLong }}</label>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>

              <!-- Info wenn Verlaufsbogen in Dokumentation oder Import und verlauf_lokaler_tumorstatus oder verlauf_tumorstatus_lymphknoten ist R -->

              <v-tooltip bottom open-delay="1000" max-width="800" v-if="base.verlauf_lokaler_tumorstatus === 'R' || base.verlauf_tumorstatus_lymphknoten === 'R'">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="layout-row layout-align-start-start ml-2" :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                       style="cursor: pointer;">
                    <v-icon :color="compColor.prime" medium>info</v-icon>
                  </div>
                </template>

                <p style="text-align: justify;" class="my-1">{{ $t('FORMS_DIVERSE.TNM_INFO_REZITIV') }}</p>
              </v-tooltip>
            </div>

            <!-- TNM-Version -->

            <div class="flex-gt-sm-33 flex-100">
              <validation-provider tag="div"
                                   :name="path + '.tnm_version'"
                                   :ref="path + '.tnm_version'"
                                   :rules="{required :isTNMDateRequired}"
                                   class="flex-gt-sm-33 flex-100 px-2"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  :label="setLabelInDependencyToRequiredState('TNM-Version')"
                  v-model="model.tnm_version"
                  :items="tnmVersions"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>

          <!-- Info Verlaufsbogen Tumorstatus-->

<!--          <div class="flex-gt-sm-100 mb-2 mx-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"-->
<!--               v-if="formKey === 'progress'"-->
<!--               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white&#45;&#45;text ' : '']"-->
<!--               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">-->
<!--            <div class="layout-column layout-align-center-center mr-3">-->
<!--              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>-->
<!--            </div>-->
<!--            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.TNM_INFO_TUMOR_STATE') }}</span>-->
<!--          </div>-->

          <div class="flex-gt-sm-100 flex-100 px-2">
            <!-- hidden input field to show error, if no tnm-value is selected and tnm is required -->
            <validation-provider tag="div"
                                 :name="path"
                                 :ref="path"
                                 :rules="{at_least_one_tnm_is_selected: [isRequired, model.tnm_t, model.tnm_n, model.tnm_m, path]}"
                                 v-slot="{ errors }">
              <lx-alert-box v-show="errors[0]" color="red" class="my-2 pa-2 report" style="font-size: 14px;">
                {{ errors[0] }}
              </lx-alert-box>

              <v-text-field
                  v-model="model"
                  v-show="false"
                  :dense="denseFields"
                  outlined
              ></v-text-field>
            </validation-provider>
          </div>

          <div class="layout-row pt-2 flex-100">

            <!-- T-Präfix -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_c_p_u_praefix_t'"
                                   :ref="path + '.tnm_c_p_u_praefix_t'"
                                   :rules="{required: !!model.tnm_t,tmn_value_required: [model.tnm_t, 'T-Wert']}"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="T-Präfix"
                  v-model="model.tnm_c_p_u_praefix_t"
                  :items="praefixes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- T-Wert -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_t'"
                                   :ref="path + '.tnm_t'"
                                   :rules="{pT1c_excluded: [diagCode, tnmValueText]}"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="T"
                  v-model="model.tnm_t"
                  :items="tTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  @change="setCpuPrefix(model.tnm_t, 'tnm_c_p_u_praefix_t')"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- m-Wert -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_m_symbol'"
                                   :ref="path + '.tnm_m_symbol'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="m – multipler Primärtumor"
                  v-model="model.tnm_m_symbol"
                  :items="mSymbolTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>

          <!-- Info Verlaufsbogen Tumorstatus-->

          <div class="flex-gt-sm-100 mb-4 mx-2 pa-3 mt-n1 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               v-if="diagCode === 'C61' && tnmValueText === 'pT1c'"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <div style="font-size: 14px;" v-bind:class="compColor.primeClass" v-html="$t('FORMS_DIVERSE.TNM_INFO_PT1C')"></div>
          </div>

          <div class="layout-row flex-100">

            <!-- N-Präfix -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_c_p_u_praefix_n'"
                                   :ref="path + '.tnm_c_p_u_praefix_n'"
                                   :rules="{required: !!model.tnm_n,tmn_value_required: [model.tnm_n, 'N-Wert']}"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="N-Präfix"
                  v-model="model.tnm_c_p_u_praefix_n"
                  :items="praefixes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :disabled="isDisabled"
                  :error-messages="errors[0]"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- N-Wert -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_n'"
                                   :ref="path + '.tnm_n'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="N"
                  v-model="model.tnm_n"
                  :items="nTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  @change="setCpuPrefix(model.tnm_n, 'tnm_c_p_u_praefix_n')"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>

          <div class="layout-row flex-100">

            <!-- M-Präfix -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_c_p_u_praefix_m'"
                                   :ref="path + '.tnm_c_p_u_praefix_m'"
                                   :rules="{required: !!model.tnm_m,tmn_value_required: [model.tnm_m, 'M-Wert']}"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="M-Präfix"
                  v-model="model.tnm_c_p_u_praefix_m"
                  :items="praefixes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- M-Wert -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_m'"
                                   :ref="path + '.tnm_m'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="M"
                  v-model="model.tnm_m"
                  :items="mTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  @change="setCpuPrefix(model.tnm_m, 'tnm_c_p_u_praefix_m')"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- LVPnS -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame label="Weitere Angaben"
                        :disabled="isDisabled">
        <div class="layout-column px-2 flex-100 mt-3">
          <div class="layout-row flex-100">
            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_l'"
                                   :ref="path + '.tnm_l'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="L – Invasion Lymphbahnen"
                  v-model="model.tnm_l"
                  :items="lTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_v'"
                                   :ref="path + '.tnm_v'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="V – Invasion Blutgefäße"
                  v-model="model.tnm_v"
                  :items="vTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.tnm_pn'"
                                   :ref="path + '.tnm_pn'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  label="Pn – Perineurale Invasion"
                  v-model="model.tnm_pn"
                  :items="pnTypes"
                  outlined
                  clearable
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :disabled="isDisabled"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>

          <!-- S-Wert mit Info -->

          <div class="layout-row flex-100">
            <validation-provider tag="div"
                                 :name="path + '.tnm_s'"
                                 :ref="path + '.tnm_s'"
                                 rules=""
                                 class="flex-gt-sm-33 flex-100 px-2"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                label="S – Serumtumormarker (C62.-)"
                v-model="model.tnm_s"
                :items="sTypes"
                outlined
                clearable
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :disabled="isDisabled"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <div class="layout-row flex-100">
            <validation-provider tag="div"
                                 :name="path + '.uicc_stadium'"
                                 :ref="path + '.uicc_stadium'"
                                 rules=""
                                 class="flex-gt-sm-33 flex-100 px-2"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                label="UICC-Stadium"
                v-model="model.uicc_stadium"
                :items="uiccStadiumTypes"
                outlined
                clearable
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :disabled="isDisabled"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>
        </div>
      </fake-input-frame>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'

export default {
  name: "TNM",
  mixins: [metaData],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    isRequired: {
      type: Boolean,
      default: () => false
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    base: {
      type: Object,
      default: () => ({})
    },
    formKey: {
      type: String
    },
    diagCode: {
      type: String
    },
    diagDate: {
      type: [Object, String]
    },
    dateOfDeath: {
      type: String
    },
    patientId: {
      type: String
    }
  },
  data () {
    return {
      model: {},
      tnmVersions: null,
      lTypes: null,
      vTypes: null,
      pnTypes: null,
      sTypes: null,
      tTypes: null,
      nTypes: null,
      mTypes: null,
      mSymbolTypes: null,
      uiccStadiumTypes: null,
      prefixClassification: [],
      prefixClassificationTypes: [
        { value: 'y', text: 'y', textLong: 'y -  Klassifikation während oder nach initialer multimodaler Therapie', model: 'tnm_y_symbol'},
        { value: 'r', text: 'r', textLong: 'r - Klassifikation erfolgte zur Beurteilung eines Rezidivs', model: 'tnm_r_symbol'},
        { value: 'a', text: 'a ',textLong: 'a - Klassifikation erfolgte durch Autopsie', model: 'tnm_a_symbol'}
      ],
      praefixes: [
        { value: 'c', text: 'c' },
        { value: 'p', text: 'p' },
        { value: 'u', text: 'u' }
      ]
    }
  },
  created () {
    this.tnmVersions = this.formsMetaData.TNM_VersionTypes
    this.lTypes = this.formsMetaData.TNM_LTypes
    this.vTypes = this.formsMetaData.TNM_VTypes
    this.pnTypes = this.formsMetaData.TNM_PnTypes
    this.sTypes = this.formsMetaData.TNM_STypes
    this.tTypes = this.formsMetaData.TNM_TTypes
    this.nTypes = this.formsMetaData.TNM_NTypes
    this.mTypes = this.formsMetaData.TNM_MTypes
    this.mSymbolTypes = this.formsMetaData.TNM_MSymbolTypes
    this.uiccStadiumTypes = this.formsMetaData.UICC_StadiumTypes
  },
  methods: {
    setLabelInDependencyToRequiredState (label) {
      return this.isTNMDateRequired ? label + ' *' : label
    },

    /**
     * Set r-classification when date is set and "rezitiv" is selected
     *
     * @param newDate The date value
     */
    setDefaultClassification (newDate) {
      if (newDate && (this.base.verlauf_lokaler_tumorstatus === 'R' || this.base.verlauf_tumorstatus_lymphknoten === 'R') && !this.model.tnm_r_symbol) {
        this.$set(this.model, 'tnm_r_symbol', 'r')
        if (this.prefixClassification.indexOf('r') < 0) this.prefixClassification.push('r')
      }
    },

    tnmPrefixIsClicked (classificationArray) {
      this.prefixClassificationTypes.forEach(listItem => {
        if (classificationArray.indexOf(listItem.value) > -1) {
          this.$set(this.model, listItem.model, listItem.value)
        } else {
          this.$set(this.model, listItem.model, null)
        }
      })
    },

    /**
     * Set tmn-version in dependency of existence of tnm-values
     *
     * @param tnmValue
     * @param oldValue
     */
    setTNM_Version (tnmValue, oldValue) {
      if (tnmValue === oldValue) {
        return
      }

      if (tnmValue && !this.model.tnm_version) {
        this.$set(this.model, 'tnm_version', this.formsMetaData.TNM_Version)
      }

      if (!this.model.tnm_t && !this.model.tnm_m_symbol && !this.model.tnm_n && !this.model.tnm_m && this.model.tnm_version) {
        this.$set(this.model, 'tnm_version', null)


        // validate tnm date manually after changing of t-, m- or n-value
        if (this.$refs && this.$refs[this.path + '.tnm_datum']) {
          this.$nextTick(() => {
            this.$refs[this.path + '.tnm_datum'].validate()
          })
        }
      }
    },

    /**
     * Set cpu-prefix after changing associated tnm-value
     *
     * @param value The value of selected tnm-value
     * @param prefix {string} THe associated prefix to tnm-value (e.g. tnm_c_p_u_praefix_t to tnm_t)
     */
    setCpuPrefix (value, prefix) {
      // set prefix of tnm-value in dependency to ctnm and ptnm
      if (value && prefix && !this.model[prefix]) {
        this.$set(this.model, prefix, this.path === 'ptnm' ? 'p' : 'c')
      }

      // delete prefix when there is no associated tnm-value
      if (!value && prefix) {
        this.$delete(this.model, prefix)
      }

      this.$nextTick(() => {
        if (this.$refs[this.path + '.tnm_datum']) {
          this.$refs[this.path + '.tnm_datum'].validate()
        }
      })
    },

    /**
     * Validate tnm-properties manually in dependency of required-status to refresh view
     */
    validateTNM () {
      // set prefixes if module is ctnm or ptnm
      if (this.model.tnm_datum || this.model.tnm_t || this.model.tnm_n || this.model.tnm_m) {
        if (this.path === 'ptnm') {
          this.model.tnm_c_p_u_praefix_t = this.model.tnm_c_p_u_praefix_t || 'p'
          this.model.tnm_c_p_u_praefix_n = this.model.tnm_c_p_u_praefix_n || 'p'
          this.model.tnm_c_p_u_praefix_m = this.model.tnm_c_p_u_praefix_m || 'p'
        }

        if (this.path === 'ctnm') {
          this.model.tnm_c_p_u_praefix_t = this.model.tnm_c_p_u_praefix_t || 'c'
          this.model.tnm_c_p_u_praefix_n = this.model.tnm_c_p_u_praefix_n || 'c'
          this.model.tnm_c_p_u_praefix_m = this.model.tnm_c_p_u_praefix_m || 'c'
        }
      } else {
        delete this.model.tnm_c_p_u_praefix_t
        delete this.model.tnm_c_p_u_praefix_n
        delete this.model.tnm_c_p_u_praefix_m
      }

      // set tnm default values if date is set and tnm values are empty
      if (this.model.tnm_datum) {
        this.model.tnm_t = this.model.tnm_t || '1'
        this.model.tnm_n = this.model.tnm_n || 'X'
        this.model.tnm_m = this.model.tnm_m || 'X'
      }
    }
  },
  watch: {
    'model.tnm_t' (newValue, oldValue) {
      this.setTNM_Version(newValue, oldValue)
    },
    'model.tnm_m_symbol' (newValue, oldValue) {
      this.setTNM_Version(newValue, oldValue)
    },
    'model.tnm_n' (newValue, oldValue) {
      this.setTNM_Version(newValue, oldValue)
    },
    'model.tnm_m' (newValue, oldValue) {
      this.setTNM_Version(newValue, oldValue)
    },
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
        this.prefixClassification = []
        // set content of helper value for y-r-a
        if (this.model.tnm_y_symbol) this.prefixClassification.push('y')
        if (this.model.tnm_r_symbol) this.prefixClassification.push('r')
        if (this.model.tnm_a_symbol) this.prefixClassification.push('a')
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    isTNMDateRequired () {
      return !!(this.isRequired || this.model.tnm_t || this.model.tnm_n || this.model.tnm_m || this.model.tnm_y_symbol || this.model.tnm_r_symbol || this.model.tnm_a_symbol)
    },
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : this.dateOfDeath
    },
    tnmValueText () {
      let returnValue = ''

      if (this.model.tnm_c_p_u_praefix_t) returnValue += this.model.tnm_c_p_u_praefix_t
      if (this.model.tnm_t) returnValue += 'T' + this.model.tnm_t
      return returnValue
    }
  }
}
</script>
